import React, { useState, useEffect, Component, ReactNode, JSX } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { oktaAuthConfig } from "../../../configOkta";
import { Security } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import Layout from "../../Layout/Layout/Layout";
import { appContext } from "../../../AppContext";
import { LogOutReason } from "../../../Common/Authentication";
import NotFound from "../../../Pages/Public/NotFound";
import LegacyRedirect from "./LegacyRedirect";
import RequiresAuth from "./RequiresAuth";
import { ILegacyRoute, IRoute, routes } from "./Routes";

export default class IbssRouter extends Component<IProps, IState>
{
    private restoreOriginalUri(originalUri: string): void
    {
        window.location.href = window.location.origin + "/auth";
    }

    public render(): JSX.Element
    {
        const oktaAuth = oktaAuthConfig;

        const routeComponents = routes
            .flatMap(route =>
            {
                const routeComponents: JSX.Element[] = [];
                if (route.legacyPaths)
                {
                    const redirects = route.legacyPaths.map(legacyPath => this.renderRedirectRoute(route, legacyPath));
                    routeComponents.push(...redirects);
                }

                if (route.component && route.isPublic)
                {
                    routeComponents.push(this.renderPublicRoute(route));
                }
                else if (route.component)
                {
                    routeComponents.push(this.renderPrivateRoute(route));
                }
                return routeComponents;
            })
            .filter(i => !!i) as JSX.Element[];

        return (
            <Security
                oktaAuth={oktaAuth}
                restoreOriginalUri={(_oktaAuth, originalUri) => this.restoreOriginalUri(originalUri)}
            >
                <BrowserRouter>
                    <Routes>
                        {[
                            ...routeComponents,
                            <Route
                                path="*"
                                element={<NotFound />}
                            />
                        ]}
                    </Routes>
                </BrowserRouter>
            </Security>
        );
    }

    private renderRedirectRoute(route: IRoute<any>, legacyPath: ILegacyRoute): JSX.Element
    {
        return (
            <Route
                key={legacyPath.path}
                path={legacyPath.path}
                element={<LegacyRedirect
                    route={route}
                    legacyPath={legacyPath}
                />}
            />
        );
    }

    private renderPublicRoute(route: IRoute<any>): JSX.Element
    {
        return (
            <Route
                key={route.path}
                path={route.path}
                element={
                    <Layout isPrivate={false}>
                        <route.component />
                    </Layout>
                }
            />
        );
    }

    private renderPrivateRoute(route: IRoute<any>): JSX.Element
    {
        return (
            <Route
                key={route.path}
                path={route.path}
                element={
                    <RequiresAuth
                        requiredRights={route.requiredRights}
                    >
                        <Layout isPrivate={true}>
                            <route.component {...route.props} />
                        </Layout>
                    </RequiresAuth>
                }
            />
        );
    }
}

export interface IProps { }
export interface IState { }
